import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const TABS = [
  { label: 'ข่าวสาร', to: '/news' },
  { label: 'นิทรรศการ', to: '/exhibition' },
  { label: 'ผลงานสร้างสรรค์', to: '/creative-works' },
  { label: 'ภาพ', to: '/images' },
  { label: 'วิดีโอ', to: '/videos' },
  { label: 'Proceeding', to: '/proceeding' },
  { label: 'บทความวิชาการ', to: '/academic-articles' },
];

const gradText = {
  background: 'linear-gradient(90deg, #BFB4EE 0%, #B3FFD1 100%)',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  fontFamily: 'Prompt',
};

const MediaNavTabs = () => {
  const { pathname } = useLocation();

  return (
    <div className="w-full py-3" style={{ background: 'linear-gradient(90deg, #533193 0%, #BFB4EE 100%)' }}>
      <div className="max-w-7xl mx-auto px-4">
        {/* overflow-x-auto = scrollable on mobile, justify-center on desktop */}
        <div className="flex items-center gap-5 sm:gap-8 overflow-x-auto scrollbar-none sm:justify-center pb-0.5">
          {TABS.map((tab) => {
            const active = pathname === tab.to || pathname.startsWith(tab.to + '/');
            return (
              <Link
                key={tab.to}
                to={tab.to}
                className="flex items-center gap-1.5 flex-shrink-0 py-1 cursor-pointer"
              >
                {active && (
                  <span className="text-sm text-white leading-none">✦</span>
                )}
                <span
                  className={`text-sm sm:text-base whitespace-nowrap ${active ? 'font-bold' : 'font-medium'}`}
                  style={gradText}
                >
                  {tab.label}
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default MediaNavTabs;
